import { render, staticRenderFns } from "./ChatFriend.vue?vue&type=template&id=3a7fba30&scoped=true&"
import script from "./ChatFriend.vue?vue&type=script&lang=js&"
export * from "./ChatFriend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7fba30",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChatAvatar: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/chat/ChatAvatar.vue').default})
